import newColors from "@/styles/newColors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	button: {
		background: newColors.grey[50],
		color: newColors.grey[800],
		fontWeight: 500,
		boxShadow: "none",
		"&:hover": {
			background: newColors.grey[100],
			color: newColors.grey[700],
			boxShadow: "none"
		}
	}
}))

export default useStyles
